module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"add-reminders":"Set a reminder frequency for each contact, and Kipinto will notify you to interact when the time comes.","reminders":"Reminders"},"fr":{"add-reminders":"Fixez une fréquence de rappel pour chaque contact, et Kipinto vous signalera d\u0027interagir le moment venu.","reminders":"Rappels"}}')
  delete Component.options._Ctor
}
